import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NgxDatatableModule } from '@siemens/ngx-datatable';

import { SharedModule } from '../../shared/shared.module';

import { CompaniesPage } from './companies.page';

const routes: Routes = [
  {
    path: '',
    component: CompaniesPage
  }
];

@NgModule({
  imports: [
    SharedModule,
    NgxDatatableModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CompaniesPage]
})
export class CompaniesPageModule {}
